import { FormLabel, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import DeliveryPriceAdditionSelect from "./DeliveryPriceAdditionSelect";
import MarketPriceSection from "./MarketPriceSection";
import MarketPriceSectionRow from "./MarketPriceSectionRow";
import OrderFormColumnCountDirectionSelect from "./OrderFormColumnCountDirectionSelect";
import OrderFormContactSelect from "./OrderFormContactSelect";
import OrderFormDeadlineHourOutputSelect from "./OrderFormDeadlineHourOutputSelect";
import OrderFormOrderQuantityOutputSelect from "./OrderFormOrderQuantityOutputSelect";
import OrderFormProductTypePartitionSelect from "./OrderFormProductTypePartitionSelect";
import OrderFormShopSummarySelect from "./OrderFormShopSummarySelect";
import ShippingDateInitialSettingSelect from "./ShippingDateInitialSettingSelect";
import UnitPriceSelect from "./UnitPriceSelect";
import UsingSellingPriceSelect from "./UsingSellingPriceSelect";
import UsingShopTable from "./UsingShopTable";
import DestinationOutputSelect from "./DestinatonOutputSelect";

const MarketPriceSettingForm = ({ form, errors }) => {

  const setting = form.marketPriceSetting;
  const changePropValue = form.changePropValue;

  const getLabelDeliveryPriceAddition = () => {
    switch (setting.deliveryPriceAdditionCd) {
      case 2:
        return '%';
      case 3:
        return '円';
      default:
        return null;
    }
  };

  const [primePriceMarkUpRate, setPrimePriceMarkUpRate] = useState(setting.primePriceMarkUpRate);
  const [sellingPriceMarkUpRate, setSellingPriceMarkUpRate] = useState(setting.sellingPriceMarkUpRate);
  const [isSellingPriceActive, setIsSellingPriceActive] = useState(setting.isUsingSellingPrice);

  useEffect(() => {
    if (!setting.isUsingSellingPrice) {
      setPrimePriceMarkUpRate(null);
      setSellingPriceMarkUpRate(null);
      setIsSellingPriceActive(false);
      changePropValue("primePriceMarkUpRate", null);
      changePropValue("sellingPriceMarkUpRate", null);
    } else {
      setPrimePriceMarkUpRate(setting.primePriceMarkUpRate);
      setSellingPriceMarkUpRate(setting.sellingPriceMarkUpRate);
      setIsSellingPriceActive(true);
    }
  }, [setting.isUsingSellingPrice]);

  const handlePrimePriceChange = (value) => {
    if (isSellingPriceActive) {
      setPrimePriceMarkUpRate(value);
      changePropValue("primePriceMarkUpRate", value);
    }
  };

  const handleSellingPriceChange = (value) => {
    if (isSellingPriceActive) {
      setSellingPriceMarkUpRate(value);
      changePropValue("sellingPriceMarkUpRate", value);
    }
  };

  const [deliveryPriceAdditionAmount, setDeliveryPriceAdditionAmount] = useState(setting.deliveryPriceAdditionAmount);
  const [isDeliveryPriceDiabled, setIsDeliveryPriceDisabled] = useState(setting.deliveryPriceAdditionCd == 1);

  useEffect(() => {
    if (setting.deliveryPriceAdditionCd == 1) {
      setDeliveryPriceAdditionAmount(null);
      setIsDeliveryPriceDisabled(true);
    } else {
      setIsDeliveryPriceDisabled(false);
    }
  }, [setting.deliveryPriceAdditionCd]);

  const handleChangeDeliveryPriceAdditionAmount = (value) => {
    if (!isDeliveryPriceDiabled) {
      setDeliveryPriceAdditionAmount(value);
      changePropValue("deliveryPriceAdditionAmount", value);
    }
  };

  return (
    <form style={{ display: 'flex', flexDirection: 'column' }}
      //onBlur={() => { validate.handleValidate(setting) }}
    >
      <MarketPriceSectionRow>
        <MarketPriceSection title="市況価格表名" width={650}>
          <TextField
            sx={{ width: 400 }}
            value={setting.marketPriceName}
            onChange={(e) => changePropValue("marketPriceName", e.target.value)}
            error={!isNullEmpty(errors.marketPriceName)}
            helperText={errors.marketPriceName}
            FormHelperTextProps={{
              sx: { marginLeft: 0 }
            }}
          />
        </MarketPriceSection>
      </MarketPriceSectionRow>

      <MarketPriceSectionRow>
        <MarketPriceSection title="売価">
          <UsingSellingPriceSelect
            value={setting.isUsingSellingPrice}
            error={errors.isUsingSellingPrice}
            onChangeValue={(v) => changePropValue("isUsingSellingPrice", v)}
          />
        </MarketPriceSection>

        <MarketPriceSection title="原価値入率">
          <TextField
            sx={{ width: 150 }}
            value={setting.primePriceMarkUpRate || ''}
            onChange={(e) => handlePrimePriceChange(e.target.value)}
            disabled={!isSellingPriceActive}
            error={!isNullEmpty(errors.primePriceMarkUpRate)}
            helperText={errors.primePriceMarkUpRate}
            InputProps={{
              sx: { '& input': { textAlign: 'right' } }
            }}
            FormHelperTextProps={{
              sx: { marginLeft: 0 }
            }}
          />
          <div style={{ textAlign: 'left' }}>
            <FormLabel sx={{
              marginLeft: '8px',
              fontSize: '20px',
            }}>
              {"%"}
            </FormLabel>
          </div>
        </MarketPriceSection>

        <MarketPriceSection title="売価値入率">
          <TextField
            sx={{ width: 150 }}
            value={setting.sellingPriceMarkUpRate || ''}
            onChange={(e) => handleSellingPriceChange(e.target.value)}
            disabled={!isSellingPriceActive}
            error={!isNullEmpty(errors.sellingPriceMarkUpRate)}
            helperText={errors.sellingPriceMarkUpRate}
            InputProps={{
              sx: { '& input': { textAlign: 'right' } }
            }}
            FormHelperTextProps={{
              sx: { marginLeft: 0 }
            }}
          />
          <div style={{ textAlign: 'left' }}>
            <FormLabel sx={{
              marginLeft: '8px',
              fontSize: '20px',
            }}>
              {"%"}
            </FormLabel>
          </div>
        </MarketPriceSection>
      </MarketPriceSectionRow>

      <MarketPriceSectionRow>
        <MarketPriceSection title="納品価格">
          <DeliveryPriceAdditionSelect
            value={setting.deliveryPriceAdditionCd}
            error={errors.deliveryPriceAdditionCd}
            onChangeValue={(v) => changePropValue("deliveryPriceAdditionCd", v)}
          />
        </MarketPriceSection>

        <MarketPriceSection title={"納品価格加算量"}>
          <TextField
            sx={{ width: 150 }}
            value={setting.deliveryPriceAdditionAmount || ''}
            onChange={(e) => handleChangeDeliveryPriceAdditionAmount(e.target.value)}
            disabled={isDeliveryPriceDiabled}
            error={!isNullEmpty(errors.deliveryPriceAdditionAmount)}
            helperText={errors.deliveryPriceAdditionAmount}
            InputProps={{
              sx: { '& input': { textAlign: 'right' } }
            }}
            FormHelperTextProps={{
              sx: { marginLeft: 0 }
            }}
          />
          <div style={{ textAlign: 'left' }}>
            <FormLabel sx={{
              marginLeft: '8px',
              fontSize: '20px',
            }}>
              {getLabelDeliveryPriceAddition()}
            </FormLabel>
          </div>
        </MarketPriceSection>
      </MarketPriceSectionRow>

      <MarketPriceSectionRow>
        <MarketPriceSection title="単価">
          <UnitPriceSelect
            value={setting.unitPriceCd}
            error={errors.unitPriceCd}
            onChangeValue={(v) => changePropValue("unitPriceCd", v)}
          />
        </MarketPriceSection>

        <MarketPriceSection title="出荷日設定">
          <ShippingDateInitialSettingSelect
            value={setting.shippingDateInitialSettingCd}
            error={errors.shippingDateInitialSettingCd}
            onChangeValue={(v) => changePropValue("shippingDateInitialSettingCd", v)}
          />
        </MarketPriceSection>
      </MarketPriceSectionRow>

      <MarketPriceSectionRow>
        <MarketPriceSection title="列数向き">
          <OrderFormColumnCountDirectionSelect
            value={setting.orderFormColumnCountDirectionCd}
            error={errors.orderFormColumnCountDirectionCd}
            onChangeValue={(v) => changePropValue("orderFormColumnCountDirectionCd", v)}
          />
        </MarketPriceSection>

        <MarketPriceSection title="店舗集約">
          <OrderFormShopSummarySelect
            value={setting.orderFormShopSummaryCd}
            error={errors.orderFormShopSummaryCd}
            onChangeValue={(v) => changePropValue("orderFormShopSummaryCd", v)}
          />
        </MarketPriceSection>

        <MarketPriceSection title="種別改ページ" >
          <OrderFormProductTypePartitionSelect
            value={setting.orderFormProductTypePartitionCd}
            error={errors.orderFormProductTypePartitionCd}
            onChangeValue={(v) => changePropValue("orderFormProductTypePartitionCd", v)}
          />
        </MarketPriceSection>
      </MarketPriceSectionRow>

      <MarketPriceSectionRow>

        <MarketPriceSection title="注文数量出力" >
          <OrderFormOrderQuantityOutputSelect
            value={setting.orderFormOrderQuantityOutputCd}
            error={errors.orderFormOrderQuantityOutputCd}
            onChangeValue={(v) => changePropValue("orderFormOrderQuantityOutputCd", v)}
          />
        </MarketPriceSection>

        <MarketPriceSection title="締切時間出力" >
          <OrderFormDeadlineHourOutputSelect
            value={setting.orderFormDeadlineHourOutputCd}
            error={errors.orderFormDeadlineHourOutputCd}
            onChangeValue={(v) => changePropValue("orderFormDeadlineHourOutputCd", v)}
          />
        </MarketPriceSection>

        <MarketPriceSection title="締切時間">
          <TextField
            sx={{ width: 150 }}
            value={setting.orderDeadlineHour}
            onChange={(e) => changePropValue("orderDeadlineHour", e.target.value)}
            disabled={setting.orderFormDeadlineHourOutputCd == 2}
            error={!isNullEmpty(errors.orderDeadlineHour)}
            helperText={errors.orderDeadlineHour}
            InputProps={{
              sx: { '& input': { textAlign: 'right' } }
            }}
            FormHelperTextProps={{
              sx: { marginLeft: 0 }
            }}
          />
          <div style={{ textAlign: 'left' }}>
            <FormLabel sx={{
              marginLeft: '8px',
              fontSize: '20px',
            }}>
              {"時"}
            </FormLabel>
          </div>
        </MarketPriceSection>
      </MarketPriceSectionRow>

      <MarketPriceSectionRow>
        <MarketPriceSection title="個人連絡先出力">
          <OrderFormContactSelect
            value={setting.orderFormContactCd}
            error={errors.orderFormContactCd}
            onChangeValue={(v) => changePropValue("orderFormContactCd", v)}
          />
        </MarketPriceSection>

        <MarketPriceSection title="あて名出力" width={600}>
          <DestinationOutputSelect
            value={setting.destinationOutputCd}
            error={errors.destinationOutputCd}
            onChangeValue={(v) => changePropValue("destinationOutputCd", v)}
          />
        </MarketPriceSection>
      </MarketPriceSectionRow>

      <MarketPriceSectionRow >
        <MarketPriceSection title="使用店舗" sx={{ width: "100%" }}>
          <UsingShopTable
            usingShops={setting.usingShops}
            onChangeShops={(usingShops) => changePropValue("usingShops", usingShops)}
            errors={errors.usingShops}
          />
        </MarketPriceSection>
      </MarketPriceSectionRow>
    </form>
  );
};

export default MarketPriceSettingForm;
